import React from 'react';
import styled from 'styled-components';
import { trackEvent } from '../analytics/analytics';

const WhatsAppFloatingButton = styled.a`
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 60px;
  height: 60px;
  background: #25d366;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 20px rgba(37, 211, 102, 0.4), 0 2px 10px rgba(0, 0, 0, 0.3);
  z-index: 1000;
  transition: all 0.3s ease;
  text-decoration: none;
  color: white;
  font-size: 1.8rem;
  border: 3px solid rgba(255, 255, 255, 0.6);
  
  &:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 25px rgba(37, 211, 102, 0.6), 0 4px 15px rgba(0, 0, 0, 0.4);
    color: white;
    border-color: rgba(255, 255, 255, 0.8);
  }
  
  &:active {
    transform: scale(0.95);
  }
  
  @media (max-width: 768px) {
    bottom: 15px;
    right: 15px;
    width: 55px;
    height: 55px;
    font-size: 1.6rem;
  }
`;

const WhatsAppIcon = styled.img`
  width: 28px;
  height: 28px;
  filter: drop-shadow(0 0 2px rgba(0, 0, 0, 0.5));
  animation: pulse 2s infinite;
  
  @keyframes pulse {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.05);
    }
    100% {
      transform: scale(1);
    }
  }
`;

const WhatsAppButton: React.FC = () => {
  const phoneNumber = '+31616752832';
  const message = 'Hallo! Ik ben geïnteresseerd in rijlessen bij UniversalDrive.';
  const whatsappUrl = `https://wa.me/${phoneNumber.replace('+', '')}?text=${encodeURIComponent(message)}`;

  const onClick = () => {
    trackEvent('cta_whatsapp_click', { location: 'floating_button' });
  };

  return (
    <WhatsAppFloatingButton
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      title="Contact ons via WhatsApp"
      onClick={onClick}
    >
      <WhatsAppIcon src="/assets/whatsapp-logo.svg" alt="WhatsApp" />
    </WhatsAppFloatingButton>
  );
};

export default WhatsAppButton;